import { authSubsGet } from "./api/authSubs";
import store from "src/store";
import { isAuthRecoveryPathname } from "./routePaths";
import { login, finishLoading } from "./store/auth";
import { UserType } from "./types";

export const validateToken = async () => {
  const token = window.localStorage.getItem("__sal_auth");
  const pathname = window.location.pathname;

  if (token && isAuthRecoveryPathname(pathname)) {
    store.dispatch(finishLoading());
    return;
  }

  if (token) {
    try {
      const response: UserType = await authSubsGet("/user/me");
      if (response?.id) {
        const redirectUrl = response.subscription?.id
          ? pathname + window.location.search
          : "/subscription";
        store.dispatch(login({ user: { ...response, accessToken: token } }));
        if (redirectUrl && pathname !== redirectUrl) {
          // window.location.replace(redirectUrl);
        }
      } else {
        store.dispatch(finishLoading());
      }
    } catch {
      store.dispatch(finishLoading());
    }
  } else {
    store.dispatch(finishLoading());
  }
};
